export default __webpack_public_path__ + "static/media/massup_s2.9357b890.png";